import './theme_lahitaksi.scss';
import ITheme from '../ITheme';
import NavigationItems from '@/navigationItems';

export default class ThemeFixutaxi implements ITheme {
    id: string = 'lahitaksi';
    matchIfHostNameContainsAny: string[] = ["lahitaksi."];
    name: string = 'Lahitaksi';
    cssClassName: string = 'theme_lahitaksi';
    dark: boolean = false;
    menuDark: boolean = false;
    toolbarDark: boolean = false;
    bottomNavDark: boolean = false;
    menuRight: boolean = false;
    booking: boolean = true;
    menuNavigationItems: INavigationItem[] = [
        NavigationItems.passengers,
        NavigationItems.trips,
        NavigationItems.cancelTrips,
        NavigationItems.booking,
        NavigationItems.personalInfo,
        NavigationItems.messages,
        NavigationItems.register,
        NavigationItems.accessibilityReport,
        NavigationItems.privacy,
    ];
    bottomNavNavigationItems: INavigationItem[] = [
        NavigationItems.booking,
        NavigationItems.trips,
        NavigationItems.cancelTrips,
        NavigationItems.messages,
    ];
    vuetifyTheme: any = {
        primary: '#ffd400',
        secondary: '#000000',
        accent: '#000000',
        warning: '#ffcb31',
        bottomNavColor: '#FFFFFF',
    };
}
